import classNames from "classnames";
import React from "react";
import classes from "./TeamSectionHeader.module.scss";

interface Props extends React.ComponentPropsWithoutRef<"div"> {
  subTitle?: string;
  title: string;
  text: string;
  children?: string | JSX.Element;
  padding?: string;
}

const TeamSectionHeader: React.FC<Props> = ({
  subTitle,
  title,
  text,
  children,
  padding,
  ...htmProps
}) => {
  return (
    <div className={classNames(classes.teamSectionHeader, htmProps.className)}>
      {subTitle && (
        <span className={classes.teamSectionHeader__subTitle}>{subTitle}</span>
      )}
      <h2 className={classes.teamSectionHeader__title}>{title}</h2>
      <p className={classes.teamSectionHeader__text}>{text}</p>
      {children}
    </div>
  );
};

export default TeamSectionHeader;
